export const welcome_message = {
  heading: "“Master the Game, Move by Move!”",
  text: `Welcome to ChessWizzania, where every move matters! Whether you're a
  beginner taking your first steps or a seasoned player aiming for mastery,
  we provide the perfect platform to learn, compete, and grow in the world
  of chess.`
};

export const about_us = {
  title: "ABOUT US",
  description: `At ChessWizzania, we shape sharp minds through the timeless game of chess. 
  Our mission is to make chess engaging, structured, and accessible for players 
  of all ages—helping beginners build strong foundations and advanced players 
  refine competitive skills.

  Through expert coaching, interactive learning, and competitive tournaments, 
  we create an environment where strategy, discipline, and confidence grow together.`,
  founder: {
    name: "Founder ChessWizzania - Satwik"
  }
};

export const why_chess = {
  title: "Why ChessWizzania?",
  points: [
    "Expert coaches dedicated to your growth",
    "Comprehensive programs for all skill levels",
    "Engaging tournaments to challenge and inspire"
  ],
  footer:
    "Join us at ChessWizzania and unlock the master strategist within you. Let's make every move count!"
};

export const what_we_do = {
  title: "What We Do",
  items: [
    {
      title: "Interactive Chess Classes",
      description:
        "Expert-led classes designed for beginners, intermediates, and advanced players to build strong fundamentals and strategic thinking."
    },
    {
      title: "Chess Tournaments",
      description:
        "Regular online and offline tournaments that help players gain real-game experience and competitive confidence."
    },
    {
      title: "Workshops & Masterclasses",
      description:
        "Focused workshops and masterclasses covering openings, middlegames, endgames, and practical tournament strategies."
    }
  ]
};
